import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import './PlaylistHeader.scss';

const formatNumber = new Intl.NumberFormat().format;

export default connect(
  ({
    playerState: { context } = {},
    currentRow,
    colorsByUri,
    previousRows,
    nextRows,
    canvasesByEntityUri,
    onDemand,
    isShuffleEnabled,
    isPremium,
  }) => {
    const previousRow = previousRows[previousRows.length - 1];
    const nextRow = nextRows[0];

    return {
      currentRow,
      previousRow,
      nextRow,
      currentRowColor: colorsByUri[currentRow?.track?.uri]?.VIBRANT,
      previousCanvas: canvasesByEntityUri[previousRow?.track?.uri],
      currentCanvas: canvasesByEntityUri[currentRow?.track?.uri],
      nextCanvas: canvasesByEntityUri[nextRow?.track?.uri],

      previousColor: colorsByUri[previousRow?.track?.uri],
      currentColor: colorsByUri[currentRow?.track?.uri],
      nextColor: colorsByUri[nextRow?.track?.uri],
      onDemand,
      isShuffleEnabled,
      isPremium,
    };
  },
  actions
)(
  React.memo(function PlaylistHeader(props) {
    // useWhyDidYouUpdate('PlaylistHeader', props);
    const {
      title = '',
      description = '',
      imageUrl,
      color,
      isFollowing,
      onClickPlayButton,
      numFollowers,
      ownerId,
      ownerDisplayName,
      ownerImageUrl,
      numTracks,
      isOwnedByCurrentUser,
      isOwnedBySpotify,
      playlistId,
      playlistUri,
      onDemand,
      isPlaying,
      isActiveContext,
      isSameFeatureIdentifier,
      isPremium,
      seeds,
      isDynamicPlaylist,
    } = props;

    const history = useHistory();

    return (
      <div className="PlaylistHeader">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox={`0 0 375 ${
            (isOwnedBySpotify ? 440 : 450) - (isDynamicPlaylist ? 24 : 0)
          }`}
        >
          <rect
            width="375"
            height="440"
            style={{
              transition: 'fill .3s ease-in-out',
              fill: color || '#606060',
            }}
          ></rect>
          <rect width="375" height="440" fill="url(#paint0_linear)"></rect>

          <g filter="url(#filter-playlist-header-cover-art-shadow)">
            <rect
              x="72"
              y="56"
              width="232"
              height="232"
              fill="#000"
              fillOpacity="0.01"
            />
          </g>

          <foreignObject x="72" y="56" width="232" height="232">
            <div
              style={{
                width: '232px',
                height: '232px',
                backgroundColor: '#282828',
                backgroundImage: imageUrl
                  ? `url(${imageUrl})`
                  : `url("data:image/svg+xml, %3Csvg viewBox='0 0 232 232' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M107 98.994V127.356C105.348 125.312 102.825 124 100 124C95.038 124 91 128.038 91 133C91 137.962 95.038 142 100 142C104.962 142 109 137.962 109 133V100.613L139 94.235V121.266C137.349 119.222 134.826 117.91 132 117.91C127.038 117.91 123 121.948 123 126.91C123 131.873 127.038 135.91 132 135.91C136.962 135.91 141 131.873 141 126.91V91.766L107 98.994ZM100 140C96.14 140 93 136.86 93 133C93 129.14 96.14 126 100 126C103.86 126 107 129.14 107 133C107 136.859 103.859 140 100 140ZM132 133.91C128.14 133.91 125 130.77 125 126.91C125 123.051 128.14 119.91 132 119.91C135.86 119.91 139 123.051 139 126.91C139 130.771 135.859 133.91 132 133.91Z' fill='%23B3B3B3'/%3E%3C/svg%3E")`,
                backgroundSize: 'cover',
                transition: 'opacity 0.3s ease-in-out',
              }}
            />
          </foreignObject>

          {!isOwnedBySpotify ? (
            <g id="title-and-owner" transform="translate(0, 0)">
              <text
                fill="#fff"
                fontSize="24"
                fontWeight="bold"
                letterSpacing="-0.96"
                style={{ whiteSpace: 'pre' }}
              >
                <tspan x="16" y="327.86">
                  {title}
                </tspan>
              </text>
              <text
                fill="#fff"
                fontSize="13"
                fontWeight="bold"
                letterSpacing="0"
                style={{ whiteSpace: 'pre' }}
              >
                <tspan x="44" y="360.257">
                  {ownerDisplayName}
                </tspan>
              </text>

              <circle
                cx="26"
                cy="356"
                r="10"
                fill={
                  ownerId
                    ? _getFallbackColorForSeed(ownerId?.length)
                    : '#282828'
                }
              />

              <text
                fill="#fff"
                style={{ whiteSpace: 'pre' }}
                fontSize="11"
                fontWeight="bold"
                letterSpacing="0em"
                textAnchor="middle"
              >
                <tspan x="26" y="360">
                  {ownerDisplayName &&
                    Array.from(ownerDisplayName)
                      ?.filter(Boolean)?.[0]
                      ?.toUpperCase()}
                </tspan>
              </text>

              <circle
                cx="26"
                cy="356"
                r="10"
                fill={
                  ownerImageUrl ? 'url(#playlist-header-owner-image)' : 'none'
                }
              />
            </g>
          ) : (
            <g transform="translate(0, 304)">
              <text
                fill="#fff"
                fillOpacity="0.7"
                style={{ whiteSpace: 'pre' }}
                fontSize="13"
                letterSpacing="0"
              >
                <tspan x="16" y="16.258">
                  {description}
                </tspan>
              </text>

              <g transform="translate(0, 32)">
                <text
                  fill="#fff"
                  style={{ whiteSpace: 'pre' }}
                  fontSize="13"
                  fontWeight="bold"
                  letterSpacing="0"
                >
                  <tspan x="44" y="16.258">
                    Spotify
                  </tspan>
                </text>
                <circle
                  cx="26"
                  cy="12"
                  r="10"
                  fill="url(#playlist-header-pattern)"
                ></circle>
              </g>

              <defs>
                <pattern
                  id="playlist-header-pattern"
                  width="1"
                  height="1"
                  patternContentUnits="objectBoundingBox"
                >
                  <use
                    transform="scale(.00141)"
                    xlinkHref="#playlist-header-image"
                  ></use>
                </pattern>
                <image
                  id="playlist-header-image"
                  width="709"
                  height="709"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAM1BMVEX///9TulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxTulxUJW2xAAAAEXRSTlMAMFCAr78gcP8QYM/vQJ+P305wlQsAAAGzSURBVHgBlNVZksQgCAZgFFFcMLn/ZWe3hkTM8r12UfzaEGHFecRAFBC9gzdiIj6gFOGRXCobasn3pdh4oeFNeWl8oZWrtsQ3aNlcGt9qsojMj5jROz/U39cq/X3mdXLhVwSU3PiVllUx8UukD/xaMUK/D46s/ayw/EHcaGcLnhvXzUcwuLLVResySuP1modmnLoa128rpIorfInz7a9FNcXfQRP/2mEQKfgricRledID0jNkj9T4pAYUfSRRUdUFEi9VdNMCAjh+ak/5OBcOPL/Qf25gTI0HnDtQxz8bVT7C6AL/wVMxoeRpvPrOJoSgU63fn8qzoFd5hwtxa/NSk7XhWX7k65eIDrE9/IzJrv/6rThVfoqNrFBlQ+tlZHDHC0N+ovW//uFQ7PkhkrG/gwfHj1E8HtqNxdBXhGMRnRQMO6+cvtnVR2tCwvLbnfhfBltEo3/6/mEqjuLxlwgMZSqPpwusknrlg9qLWmOlPnxsgjeqy+PXZi/nLs3OY6veN+O5+Sy9DgQAAAAABCHsbztEFDeEDhILcQdWCGiEUoC4iI8AVyGzYB02gQfF18injHZwF6RON3rh/wUAAAAASUVORK5CYII="
                ></image>
              </defs>
            </g>
          )}

          <g
            transform={`translate(0, ${
              (isOwnedBySpotify ? 368 : 376) - (isDynamicPlaylist ? 24 : 0)
            })`}
            id="buttons-and-metadata"
          >
            <g
              onClick={onClickPlayButton}
              style={{ pointerEvents: 'bounding-box' }}
            >
              <circle cx="332" cy="28" r="28" fill="#1DB954"></circle>

              {isPlaying && isActiveContext && isSameFeatureIdentifier ? (
                <g transform="translate(304, 0)">
                  <path
                    d="M31.5 18.375V37.625C31.5 38.15 31.85 38.5 32.375 38.5H35.875C36.4 38.5 36.75 38.15 36.75 37.625V18.375C36.75 17.85 36.4 17.5 35.875 17.5H32.375C31.85 17.5 31.5 17.85 31.5 18.375ZM20.125 38.5H23.625C24.15 38.5 24.5 38.15 24.5 37.625V18.375C24.5 17.85 24.15 17.5 23.625 17.5H20.125C19.6 17.5 19.25 17.85 19.25 18.375V37.625C19.25 38.15 19.6 38.5 20.125 38.5Z"
                    fill="white"
                  />
                </g>
              ) : (
                <path
                  fill="#fff"
                  fillRule="evenodd"
                  d="M326.312 37.742l15.562-8.984a.874.874 0 000-1.516l-15.562-8.984a.875.875 0 00-1.312.758v17.968a.875.875 0 001.312.758z"
                  clipRule="evenodd"
                ></path>
              )}

              {isDynamicPlaylist ? null : (
                <g>
                  <circle cx="354" cy="50" r="10" fill="#fff"></circle>
                  <path
                    fill="#1DB954"
                    fillRule="evenodd"
                    d="M354.472 47.943c.61-.665 1.464-1.068 2.59-1.068v-1.25l2.626 1.875-2.626 1.875v-1.25c-.631 0-1.168.167-1.602.64l-3.025 3.292a3.358 3.358 0 01-2.47 1.068h-.777v-1.25h.777a2.01 2.01 0 001.481-.64l3.026-3.292zm-2.763 1.108l.872-.95c-.689-.75-1.491-1.226-2.616-1.226h-.777v1.25h.777c.841 0 1.248.387 1.744.926zm5.353 2.824c-.979 0-1.32-.333-1.865-.926l-.872.95c.711.773 1.474 1.226 2.737 1.226v1.25l2.626-1.875-2.626-1.875v1.25z"
                    clipRule="evenodd"
                  ></path>
                  <mask
                    width="11"
                    height="10"
                    x="349"
                    y="45"
                    maskUnits="userSpaceOnUse"
                  >
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M354.472 47.943c.61-.665 1.464-1.068 2.59-1.068v-1.25l2.626 1.875-2.626 1.875v-1.25c-.631 0-1.168.167-1.602.64l-3.025 3.292a3.358 3.358 0 01-2.47 1.068h-.777v-1.25h.777a2.01 2.01 0 001.481-.64l3.026-3.292zm-2.763 1.108l.872-.95c-.689-.75-1.491-1.226-2.616-1.226h-.777v1.25h.777c.841 0 1.248.387 1.744.926zm5.353 2.824c-.979 0-1.32-.333-1.865-.926l-.872.95c.711.773 1.474 1.226 2.737 1.226v1.25l2.626-1.875-2.626-1.875v1.25z"
                      clipRule="evenodd"
                    ></path>
                  </mask>
                </g>
              )}
            </g>

            <foreignObject width="286" height="44" x="10" y="18">
              <div
                className="PlaylistHeader__actions"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'grid',
                  alignItems: 'center',
                  gap: '16px',
                  gridAutoFlow: 'column',
                  gridAutoColumns: 'min-content',
                  paddingLeft: '6px',
                }}
              >
                {isOwnedByCurrentUser !== false ? null : isFollowing ? (
                  <span>
                    <svg
                      width="94"
                      height="28"
                      viewBox="0 0 94 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.4534 17V14.24H17.2034V12.97H14.4434V11.22H17.5434V9.91H13.0634V17H14.4534ZM20.7179 13.45C20.7179 11.85 21.8379 11.09 22.9279 11.09C24.0279 11.09 25.1479 11.85 25.1479 13.45C25.1479 15.05 24.0279 15.81 22.9279 15.81C21.8379 15.81 20.7179 15.05 20.7179 13.45ZM19.2879 13.46C19.2879 15.74 21.0079 17.15 22.9279 17.15C24.8579 17.15 26.5779 15.74 26.5779 13.46C26.5779 11.17 24.8579 9.76 22.9279 9.76C21.0079 9.76 19.2879 11.17 19.2879 13.46ZM33.3534 17V15.68H30.1934V9.91H28.8134V17H33.3534ZM39.8807 17V15.68H36.7207V9.91H35.3407V17H39.8807ZM42.6535 13.45C42.6535 11.85 43.7735 11.09 44.8635 11.09C45.9635 11.09 47.0835 11.85 47.0835 13.45C47.0835 15.05 45.9635 15.81 44.8635 15.81C43.7735 15.81 42.6535 15.05 42.6535 13.45ZM41.2235 13.46C41.2235 15.74 42.9435 17.15 44.8635 17.15C46.7935 17.15 48.5135 15.74 48.5135 13.46C48.5135 11.17 46.7935 9.76 44.8635 9.76C42.9435 9.76 41.2235 11.17 41.2235 13.46ZM57.3025 14.81L55.7225 9.91H54.2925L52.7225 14.79L51.4225 9.91H49.9625L51.9325 17H53.3725L54.9925 11.95L56.6125 17H58.0325L59.9925 9.91H58.5825L57.3025 14.81ZM63.4126 17V9.91H62.0126V17H63.4126ZM72.1193 17V9.91H70.7393V14.6L67.7893 9.91H66.0693V17H67.4493V11.97L70.6693 17H72.1193ZM81.2041 17V13.31H77.6641V14.51H79.9041C79.8241 15.01 79.3141 15.89 78.0041 15.89C76.8141 15.89 75.7641 15.06 75.7641 13.46C75.7641 11.78 76.9241 11.05 77.9941 11.05C79.1441 11.05 79.7341 11.78 79.9141 12.41L81.2341 11.94C80.8841 10.85 79.8541 9.76 77.9941 9.76C76.0741 9.76 74.3641 11.17 74.3641 13.46C74.3641 15.75 75.9941 17.15 77.9041 17.15C78.9741 17.15 79.6741 16.67 79.9941 16.19L80.0841 17H81.2041Z"
                        fill="white"
                      />

                      <rect
                        width="93"
                        height="27"
                        x="0.5"
                        y="0.5"
                        stroke="#fff"
                        rx="3.5"
                      ></rect>
                    </svg>
                  </span>
                ) : (
                  <span>
                    <svg
                      width="72"
                      height="28"
                      viewBox="0 0 72 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.2454 17V14.24H16.9954V12.97H14.2354V11.22H17.3354V9.91H12.8554V17H14.2454ZM20.5099 13.45C20.5099 11.85 21.6299 11.09 22.7199 11.09C23.8199 11.09 24.9399 11.85 24.9399 13.45C24.9399 15.05 23.8199 15.81 22.7199 15.81C21.6299 15.81 20.5099 15.05 20.5099 13.45ZM19.0799 13.46C19.0799 15.74 20.7999 17.15 22.7199 17.15C24.6499 17.15 26.3699 15.74 26.3699 13.46C26.3699 11.17 24.6499 9.76 22.7199 9.76C20.7999 9.76 19.0799 11.17 19.0799 13.46ZM33.1454 17V15.68H29.9854V9.91H28.6054V17H33.1454ZM39.6727 17V15.68H36.5127V9.91H35.1327V17H39.6727ZM42.4455 13.45C42.4455 11.85 43.5655 11.09 44.6555 11.09C45.7555 11.09 46.8755 11.85 46.8755 13.45C46.8755 15.05 45.7555 15.81 44.6555 15.81C43.5655 15.81 42.4455 15.05 42.4455 13.45ZM41.0155 13.46C41.0155 15.74 42.7355 17.15 44.6555 17.15C46.5855 17.15 48.3055 15.74 48.3055 13.46C48.3055 11.17 46.5855 9.76 44.6555 9.76C42.7355 9.76 41.0155 11.17 41.0155 13.46ZM57.0945 14.81L55.5145 9.91H54.0845L52.5145 14.79L51.2145 9.91H49.7545L51.7245 17H53.1645L54.7845 11.95L56.4045 17H57.8245L59.7845 9.91H58.3745L57.0945 14.81Z"
                        fill="white"
                      />

                      <rect
                        width="71"
                        height="27"
                        x="0.5"
                        y="0.5"
                        stroke="#fff"
                        rx="3.5"
                        strokeOpacity="0.3"
                      ></rect>
                    </svg>
                  </span>
                )}

                {isPremium && (
                  <span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5 0C5.149 0 0 5.148 0 11.5C0 17.851 5.149 23 11.5 23C17.851 23 23 17.851 23 11.5C23 5.148 17.851 0 11.5 0ZM11.5 22C5.71 22 1 17.29 1 11.5C1 5.71 5.71 1 11.5 1C17.29 1 22 5.71 22 11.5C22 17.29 17.29 22 11.5 22ZM11.999 15.158V5H10.999V15.149L7.581 11.174L6.823 11.826L11.501 17.266L16.195 11.827L15.438 11.174L11.999 15.158Z"
                        fill="#B3B3B3"
                      />
                    </svg>
                  </span>
                )}

                <span
                  id="more-button"
                  onClick={() => props.openContextMenu(playlistUri)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 11C3.7 11 3 11.7 3 12.5C3 13.3 3.7 14 4.5 14C5.3 14 6 13.3 6 12.5C6 11.7 5.3 11 4.5 11ZM19.5 11C18.7 11 18 11.7 18 12.5C18 13.3 18.7 14 19.5 14C20.3 14 21 13.3 21 12.5C21 11.7 20.3 11 19.5 11ZM12 11C11.2 11 10.5 11.7 10.5 12.5C10.5 13.3 11.2 14 12 14C12.8 14 13.5 13.3 13.5 12.5C13.5 11.7 12.8 11 12 11Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </span>
              </div>
            </foreignObject>

            <text
              fill="#fff"
              fillOpacity="0.7"
              style={{ whiteSpace: 'pre' }}
              fontSize="13"
              letterSpacing="0"
            >
              <tspan x="16" y="13.258">
                {numFollowers > 0
                  ? `${formatNumber(numFollowers || 0)}  likes${
                      isDynamicPlaylist ? '' : ` • `
                    }`
                  : ''}
                {isDynamicPlaylist
                  ? ''
                  : `${numTracks == null ? '' : numTracks} ${
                      numTracks != null
                        ? `song${numTracks !== 1 ? 's' : ''}`
                        : ''
                    }`}
              </tspan>
            </text>
          </g>

          <defs>
            <filter
              id="filter-playlist-header-cover-art-shadow"
              width="368"
              height="368"
              x="3"
              y="2"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              ></feColorMatrix>
              <feOffset dy="4"></feOffset>
              <feGaussianBlur stdDeviation="30"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              ></feBlend>
            </filter>

            <linearGradient
              id="paint0_linear"
              x1="187.5"
              x2="187.5"
              y1="0"
              y2="412"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#121212" stopOpacity="0"></stop>
              <stop offset="1" stopColor="#121212"></stop>
            </linearGradient>
            <linearGradient
              id="paint2_linear"
              x1="187.5"
              x2="187.5"
              y1="0"
              y2="88"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0.16"></stop>
              <stop offset="0.698" stopOpacity="0"></stop>
              <stop offset="1" stopOpacity="0"></stop>
            </linearGradient>

            <pattern
              id="playlist-header-owner-image"
              width="1"
              height="1"
              patternContentUnits="objectBoundingBox"
            >
              <image
                id="image3"
                width="900"
                height="900"
                xlinkHref={ownerImageUrl}
                transform="scale(.00111)"
              ></image>
            </pattern>
          </defs>
        </svg>
      </div>
    );
  })
);

const truncate = (str, maxLen) =>
  str?.length > maxLen ? `${str.substr(0, maxLen - 1)}…` : str;

export function _getFallbackColorForSeed(seed) {
  const palette = [
    '#F573A0',
    '#19E68C',
    '#509BF5',
    '#B49BC8',
    '#FF6437',
    '#C87D55',
  ];
  return palette[seed % palette.length];
}
